import React from "react";
import { hourFormat, dateFormat } from "functions/functions";
import { API_URL_IMG } from "constantes/constantes";
import "./card.sass";

export default function Card({ imagen, titulo, horaInicio, horaFin, enlace, tipo, disciplina, disciplina_id, porDeporte, targetB, estaEnvivo }) {

    let noImage = `${API_URL_IMG}/assets-v3/plugins-olimpicos/amx-notas-homes/assets/images/olimpicos-paris.png`
    let urlOriginal = imagen && imagen.length > 0 ? imagen : noImage;

    // Funcion para obtener la extension de la URL
    const obtenerExtension = (url) => {
        // Obtiene el ultimo segmento de la URL despues de la ultima barra '/'
        let filename = url.substring(url.lastIndexOf('/') + 1);
        // Obtiene la extensión del archivo (lo que está despues del ultimo punto '.')
        let extension = filename.substring(filename.lastIndexOf('.') + 1);

        return extension;
    };

    // Llama a la funcion para obtener la extensión dinamicamente
    let extension = obtenerExtension(urlOriginal);
    let regex = new RegExp(`\\.${extension}$`, 'i'); // 'i' la búsqueda sera insensible a mayusculas/minusculas
    let newUrl = urlOriginal.replace(regex, '');

    return (
        <a className={tipo === 'imagen' ? "container-card-envivo borderLight" : "container-card-envivo"} href={enlace} target={String(targetB) === "true" ? "_blank" : "_top"} rel="noreferrer">

            {tipo === 'imagen'
                ?
                <div className="seccion-img">
                    <i className="AMX-icon-play"></i>
                    <img
                        loading="lazy"
                        decoding="async"
                        src={imagen && imagen.length > 0 ? imagen : noImage}
                        className={imagen && imagen.length > 0 ? "imagen-portada" : 'sin-imagen-portada'}
                        alt={titulo}
                        srcSet={`${newUrl}-768x432.${extension} 768w, ${newUrl}-300x169.${extension} 300w, ${newUrl}-1024x576.${extension} 1024w, ${urlOriginal} 1200w`}
                        sizes="(max-width: 768px) 100vw, 768px"
                    />
                </div>
                :
                <div className="seccion-icono">
                    <i className={"AMX-" + disciplina_id}></i>
                </div>
            }

            <div className="seccion-contenido">
                {estaEnvivo &&
                    <div className="title-status">
                        <h4 className="contenido-title">{disciplina}</h4>
                        <div className="status-live">En vivo</div>
                    </div>
                }
                

                <h3 className={"contenido-resumen"}>{titulo}</h3>

                {/*contenido para widget EN VIVO POR DEPORTE */}
                {porDeporte
                    ? <div className="contenido-date">
                        <time dateTime={horaInicio} className="hour paddingR5"> {dateFormat(horaInicio)}, {hourFormat(horaInicio)}</time> -
                        <time dateTime={horaFin} className="hour paddingL5">{hourFormat(horaFin)}</time>
                    </div>
                    : <div className="contenido-date"> {/*contenido para widget EN VIVO - RESULTADOS COMPLETOS DEL DIA  y FILTRADOS */}
                        <time dateTime={horaInicio} className="hour paddingR5">{dateFormat(horaInicio)}, {hourFormat(horaInicio)}</time> - 
                        <time dateTime={horaFin} className="hour paddingL5">{hourFormat(horaFin)}</time>
                    </div>
                }
            </div>
        </a>
    )
}